import styled from 'styled-components'

type WrapperProps = {
  $show?: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  gap: var(--spacer-2);
  right: var(--spacer-3);
  top: 1.125rem;
  transform: translateY(-50%);
  transition: opacity 0.2s;
  opacity: ${({ $show }) => ($show ? 1 : 0)};
  user-select: none;
`

Wrapper.displayName = 'Wrapper'
